import CORPORATION_SCOPE_TYPE from '@/constants/corporationScopeType'
import { computed, inject } from 'vue'
import INJECTION_KEYS from '@injectionKeys'
import CORPORATION_TYPE from '@/constants/corporationType'


export const useCorporationScope = () => {
    /** @type {Session} */
    const session = inject(INJECTION_KEYS.SESSIONSTATE)

    const corporationScope = computed(() => {
        switch (session.corporation.corporationType) {
            case CORPORATION_TYPE.SCHOOL_AUTHORITY: return CORPORATION_SCOPE_TYPE.SCHOOL_AUTHORITIES
            case CORPORATION_TYPE.SCHOOL: return CORPORATION_SCOPE_TYPE.SCHOOLS
            default: return undefined
        }
    })

    return {
        corporationScope
    }
}